import React, {useEffect} from 'react'
import styled from '@emotion/styled'
import {PreferencesOverlay} from 'components/PreferencesOverlay'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {cssTheme} from '@vio/atlas/themes'
import {useIsEmbeddedWithBrand} from '@vio/core/src/_web/brand/hooks/useIsEmbeddedWithBrand'
import {getDataDogRumInstance} from '@vio/core/src/analytics/components/DataDogClient'
import {Page} from '@vio/core/src/analytics/types/Events'

import {DesktopHeader} from './DesktopHeader'
import {MobileHeader} from './MobileHeader'

interface HeaderWithStoreProps {
  currentLanguage: string
  ddPagePrefix?: 'pp'
  disableLogoClick?: boolean
  disablePreferences?: boolean
  hasCurrencySelector?: boolean
  hasLanguageSelector?: boolean
  hasUserWidget?: boolean
  mobileCenterContent?: React.ReactElement
  onBackButtonClick?: () => void
  hideMyBooking?: boolean
  hideReferral?: boolean
  preferenceTitle?: JSX.Element
  pageName?: Page
  hideManageAccount?: boolean
  onCurrencyChange?: (currency: string) => void
  showStartLogo?: boolean
}

// TODO (@select): the margin-bottom should be moved to parent layout
const DesktopWrapper = styled('div')`
  margin-bottom: ${cssTheme.layout.spacing.s500};
`

export const HeaderWithStore = ({
  // Mobile
  hasCurrencySelector,
  hasLanguageSelector,
  mobileCenterContent,
  onBackButtonClick,

  // Desktop
  hasUserWidget = true,
  hideManageAccount = false,

  //Common
  disableLogoClick = false,
  disablePreferences = false,
  currentLanguage,
  ddPagePrefix,
  hideMyBooking,
  hideReferral,
  preferenceTitle,
  pageName,
  onCurrencyChange,
  showStartLogo
}: HeaderWithStoreProps) => {
  const {isMobile} = useDeviceLayout()
  const isEmbedded = useIsEmbeddedWithBrand()

  useEffect(() => {
    if (ddPagePrefix) {
      getDataDogRumInstance().addTiming(`${ddPagePrefix}HeaderRendered`)
    }
  }, [ddPagePrefix])

  if (isEmbedded && !isMobile) {
    return null
  }

  return isMobile ? (
    <>
      <MobileHeader
        centerContent={mobileCenterContent}
        hasHeaderMenu={!disablePreferences}
        disableLogoClick={disableLogoClick}
        onBackButtonClick={onBackButtonClick}
        pageName={pageName}
        showStartLogo={showStartLogo}
      />
      {!disablePreferences && (
        <>
          <PreferencesOverlay
            onCurrencyChange={onCurrencyChange}
            currentLanguage={currentLanguage}
            hasLanguageSelector={hasLanguageSelector}
            hasCurrencySelector={hasCurrencySelector}
            preferenceTitle={preferenceTitle}
            hideMyBooking={hideMyBooking}
            hideReferral={hideReferral}
            pageName={pageName}
          />
        </>
      )}
    </>
  ) : (
    <DesktopWrapper>
      <DesktopHeader
        page={pageName}
        hideMyBookings={hideMyBooking}
        disableLogoClick={disableLogoClick}
        disablePreferences={disablePreferences}
        hasCurrencySelector={hasCurrencySelector}
        hasUserWidget={hasUserWidget}
        hideManageAccount={hideManageAccount}
        onCurrencyChange={onCurrencyChange}
      />
    </DesktopWrapper>
  )
}
